import axios from "../lib/axios";

const fetchStatusCounts = async (parentId) => {
  try {
    const res = await axios.get("ModuleMst/GetTableStatusCounts", { params: { parentId } });

    if (res.data && res.data.Data) {
      return res.data.Data;
    } else {
      console.error("No data found in response");
      return [];
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export default fetchStatusCounts;

